module.exports = __webpack_public_path__ + "img/5C7F1583.22ebe9bd.png";